import { useState } from "react";
import "./FAQSection.css";

function FAQItem({ item, isOpen, onToggle, index }) {
  return (
    <div className={`faq-item${isOpen ? " faq-item--open" : ""}`}>
      <button
        className="faq-item__question"
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-controls={`faq-answer-${index}`}
        id={`faq-question-${index}`}
      >
        <span>{item.question}</span>
        <span className="faq-item__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="18" height="18">
            <path
              d="M6 9l6 6 6-6"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </button>

      <div
        className="faq-item__answer-wrapper"
        id={`faq-answer-${index}`}
        role="region"
        aria-labelledby={`faq-question-${index}`}
      >
        <div className="faq-item__answer">
          <p>{item.answer}</p>
        </div>
      </div>
    </div>
  );
}

export default function FAQSection({ faq = {} }) {
  const { heading, subheading, list = [] } = faq;
  const [openIndex, setOpenIndex] = useState(0);

  if (!list.length) return null;

  const toggle = (i) => setOpenIndex((prev) => (prev === i ? -1 : i));

  return (
    <section className="faq-section section" id="faq">
      <div className="container">
        <h2 className="section-heading">
          {heading || "Frequently Asked Questions"}
        </h2>
        {subheading && <p className="faq-subheading">{subheading}</p>}

        <div className="faq-list">
          {list.map((item, i) => (
            <FAQItem
              key={i}
              index={i}
              item={item}
              isOpen={openIndex === i}
              onToggle={() => toggle(i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
